import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Snackbar,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { API, Auth, graphqlOperation } from "aws-amplify";
import React from "react";
import { createUserProfile, updateUserProfile } from "../graphql/mutations";
import { getUserProfile } from "../graphql/queries";
import theme from "../components/mainTheme";
import { getCategories, getCategoryById } from "components/categoryHelper";
import { SubCategories } from "components/SubCategories";

export default function MyProfile(props) {
  const [email, setEmail] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [orgNumber, setOrgNumber] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [id, setId] = React.useState(null);
  const [hasUserProfile, setHasUserProfile] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState("");
  const [errors, setErrors] = React.useState("");

  const [categories, setCategories] = React.useState([]);
  const [subCategories, setSubCategories] = React.useState([]);

  const validateForm = () => {
    let temp = {};
    temp.phoneNumber = phoneNumber.trim()
      ? ""
      : "Du måste lägga till ett telefonnummer!";
    temp.firstName = firstName.trim() ? "" : "Vänligen fyll i förnamn!";
    temp.lastName = lastName.trim() ? "" : "Vänligen fyll i efternamn!";
    temp.company = company.trim() ? "" : "Vänligen fyll i företag!";

    setErrors({ ...temp });

    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = () => {
    const posta = validateForm();
    if (!posta) {
      return false;
    } else {
      const data = {
        firstName,
        lastName,
        subCategories,
        category: categories,
        company,
        company_orgNumber: orgNumber,
        id,
        email,
        phone: phoneNumber,
      };

      const obj = {
        input: data,
      };

      //Create OR update user profile
      if (hasUserProfile === true) {
        const promise = API.graphql(graphqlOperation(updateUserProfile, obj));
        promise.then(() => {
          setToastMessage("Ditt konto är uppdaterat!");
          const myEvent = new Event("jojoo_profileupdated", {});
          document.dispatchEvent(myEvent);
        });
        promise.catch(() => {
          setToastMessage("Något gick fel");
        });
      } else if (hasUserProfile === false) {
        const promise = API.graphql(graphqlOperation(createUserProfile, obj));
        promise.then(() => {
          setToastMessage("Ditt konto är uppdaterat!");
          const myEvent = new Event("jojoo_profileupdated", {});
          document.dispatchEvent(myEvent);
        });

        promise.catch(() => {
          setToastMessage("Något gick fel!");
        });
      }
    }
  };
  React.useEffect(() => {
    const bla = async () => {
      try {
        const data = await Auth.currentAuthenticatedUser();

        setEmail(data.attributes.email);
        //if (!hasUserProfile) {
        //  setPhoneNumber(data.attributes.phone_number);
        //}

        setId(data.attributes.sub);
        //Get User Profile from data store
        const variables = {
          id: data.attributes.sub,
        };

        const userProfileData = await API.graphql(
          graphqlOperation(getUserProfile, variables)
        );
        const userProfile = userProfileData.data.getUserProfile;
        setCategories(userProfile.category);
        setSubCategories(userProfile.subCategories || []);
        setFirstName(userProfile.firstName);
        setLastName(userProfile.lastName);
        setCompany(userProfile.company);
        setOrgNumber(userProfile.company_orgNumber);
        setPhoneNumber(userProfile.phone);
        setHasUserProfile(true);
      } catch (e) {
        console.error(e);
      }
    };
    bla();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md">
        <Box padding={"5%"} style={{ background: "white" }}>
          <h1>Mitt konto</h1>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={!!toastMessage}
            autoHideDuration={2000}
            message="Ditt konto är uppdaterat"
            action={
              <React.Fragment>
                <IconButton
                  aria-label="close"
                  color="inherit"
                  onClick={(event) => setToastMessage("")}
                >
                  <Close fontSize="small" />
                </IconButton>
              </React.Fragment>
            }
          />

          <form noValidate autoComplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Förnamn"
                  variant="outlined"
                  color="primary"
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  value={firstName}
                  required
                  fullWidth={true}
                  onChange={(event) => setFirstName(event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Efternamn"
                  value={lastName}
                  variant="outlined"
                  required
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                  fullWidth={true}
                  onChange={(event) => setLastName(event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Företagsnamn"
                  variant="outlined"
                  value={company}
                  error={!!errors.company}
                  helperText={errors.company}
                  onChange={(event) => setCompany(event.target.value)}
                  fullWidth={true}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Organisationsnummer"
                  variant="outlined"
                  value={orgNumber}
                  onChange={(event) => setOrgNumber(event.target.value)}
                  fullWidth={true}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  variant="outlined"
                  disabled
                  fullWidth={true}
                  value={email}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Telefonnummer"
                  variant="outlined"
                  value={phoneNumber}
                  error={!!errors.phoneNumber}
                  helperText={errors.phoneNumber}
                  onChange={(event) => setPhoneNumber(event.target.value)}
                  fullWidth={true}
                  required
                />
              </Grid>
              {Object.values(getCategories()).map((cat) => {
                function hasCategory(name) {
                  if (!categories) {
                    return false;
                  }
                  return categories.indexOf(name) > -1;
                }

                const addCategory = () => {
                  if (!categories) {
                    const newArray = [];
                    newArray.push(cat.id);
                    setCategories(newArray);
                  } else {
                    const copy = categories.map((c) => c);
                    //Check that category does not already exist
                    if (copy.indexOf(cat.id) === -1) {
                      copy.push(cat.id);
                      setCategories(copy);
                    }
                  }
                };
                const removeCategory = () => {
                  //remove category
                  //Filter ut categories that are NOT this category
                  if (!categories) {
                    return false;
                  }
                  const clone = categories.filter((c) => c !== cat.id);
                  setCategories(clone);
                };

                const onChangeCategory = (e) => {
                  if (e.target.checked === true) {
                    addCategory();
                    //Categories does not exist
                  } else {
                    removeCategory();
                  }
                };

                const catObj = getCategoryById(cat.id);

                return (
                  <Grid item md={6} xs={12} key={cat.id}>
                    <label>
                      <input
                        type="checkbox"
                        name={cat.id}
                        key={cat.id}
                        onChange={onChangeCategory}
                        checked={hasCategory(cat.id)}
                      />
                      {catObj.label}
                    </label>

                    {catObj.subCategories.map((sub) => {
                      const onChangeSubCategory = (e) => {
                        if (e.target.checked === true) {
                          if (!subCategories) {
                            return false;
                          }
                          //We need to create a copy of the array since React STATE using references
                          const copy = subCategories.map((c) => c);
                          if (copy.indexOf(sub) === -1) {
                            copy.push(sub);
                            setSubCategories(copy);
                            addCategory(); //add parent category
                          }
                        } else {
                          //remove category
                          //Filter ut categories that are NOT this category
                          const clone = subCategories.filter((c) => c !== sub);
                          setSubCategories(clone);
                        }
                      };

                      const isChecked = subCategories.indexOf(sub) > -1;
                      return (
                        <Grid item xs={12} key={sub}>
                          <label style={{ marginLeft: "20px" }}>
                            <input
                              type="checkbox"
                              checked={isChecked}
                              name={sub}
                              key={sub}
                              value={sub}
                              onChange={onChangeSubCategory}
                            />
                            {sub}
                          </label>
                        </Grid>
                      );
                    })}
                  </Grid>
                );
              })}

              <Grid item xs={12} sm={12}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Uppdatera konto
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
